import { faLongArrowRight } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.grey[800],
  fontWeight: 300
}))

function RouterLink(props) {
  const { children, to } = props

  return (
    <StyledLink to={to}>
      {children} <FontAwesomeIcon icon={faLongArrowRight} />
    </StyledLink>
  )
}

export default RouterLink
